
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "ToolBar"
})
export default class ToolBar extends BaseVue {
  @Prop({ default: "" })
  operates!: String; // 模块按钮权限列表
  @Prop({ default: () => [] })
  btnList!: any; // 工具栏列表
  @Prop({ default: "" })
  eventReturn!: any; //按钮点击事件返回参数
  @Prop({ default: false })
  ButtonGroup!: Boolean; // 是否按钮组
  mounted() {
    console.log('btnList',this.btnList )
    let _this = this;
  }
  setData(data){
    if(this.isNull(data)){
      this.btnList = data
    }
  }
}
